import { CheckoutContextProvider } from "@@/carts/checkout.context";
import { CartContextProvider } from "@@/carts/multi-carts/cart.context";
import { MultiCartContextProvider } from "@@/carts/multi-carts/multi-cart.context";
import { ProductDetailsContextProvider } from "@@/products/product-details-context";
import { VoucherPurchaseV2 } from "@@/routes/products/$productId/_voucher/voucher-purchase-v2";
import type { Provider, Voucher_Product } from "@towni/common";

type Props = {
    readonly voucher: Voucher_Product;
    readonly provider: Provider;
};

const VoucherPageV2 = (props: Props) => {
    const voucher = props.voucher;
    return <_VoucherPageV2 voucher={voucher} provider={props.provider} />;
};

function _VoucherPageV2(props: {
    readonly voucher: Voucher_Product;
    readonly provider: Provider;
}) {
    const product = props.voucher;
    const provider = props.provider;

    if (provider.options.useProviderCartForVoucher) {
        return (
            <ProductDetailsContextProvider
                product={product}
                provider={provider}>
                <VoucherPurchaseV2
                    provider={provider}
                    product={props.voucher}
                    hideLinkToShop
                />
            </ProductDetailsContextProvider>
        );
    }

    return (
        <MultiCartContextProvider
            contextId={`ctx_${product._id}`}
            preservationDisabled={true}>
            <CartContextProvider
                key={provider._id}
                providerId={provider._id}
                doNotPreserveCart>
                <CheckoutContextProvider>
                    <ProductDetailsContextProvider
                        product={product}
                        provider={provider}>
                        <VoucherPurchaseV2
                            provider={provider}
                            product={props.voucher}
                            hideLinkToShop
                        />
                    </ProductDetailsContextProvider>
                </CheckoutContextProvider>
            </CartContextProvider>
        </MultiCartContextProvider>
    );
}

export { VoucherPageV2 };
